import { QRCodeSVG } from "qrcode.react";
import ModalGeneric from "./ModalGeneric";
import Countdown from "./CountDown";

/* eslint-disable react/prop-types */
function CheckoutQR({ activeModal, setActiveModal, navigate }) {
    const openPaymentOptions = () => {
        window.location.href = activeModal.url;
    };
    const closeModal = () => setActiveModal({ isVisible: false });

    return (
        <ModalGeneric
            isVisible={activeModal.isVisible}
            onClose={closeModal}
        >
            <div className="flex flex-col">
                <div className="flex items-start justify-between gap-3">
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-[0.28em] text-rose-300/80">
                            Pago seguro
                        </p>
                        <h3 className="mt-2 text-2xl font-semibold text-white">
                            Escaneá el QR y finalizá tu compra
                        </h3>
                    </div>
                    <div className="rounded-full border border-rose-500/20 bg-rose-500/10 px-3 py-1 text-xs font-medium text-rose-200">
                        15 min
                    </div>
                </div>

                <div className="mt-5 rounded-2xl border border-white/10 bg-white p-4 shadow-[0_18px_40px_rgba(15,23,42,0.18)]">
                    <div className="flex justify-center">
                        <QRCodeSVG
                            value={activeModal.qr_code}
                            size={240}
                            className="h-auto w-full max-w-[240px]"
                        />
                    </div>
                </div>

                <div className="mt-4 flex flex-col items-center gap-1">
                    <Countdown initialSeconds={900} onComplete={closeModal} />
                    <p className="text-sm text-zinc-300">
                        Usá tu billetera o seguí con tarjeta.
                    </p>
                </div>

                <div className="mt-5 grid gap-3 sm:grid-cols-2">
                    <button
                        className="inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-rose-500/20 bg-rose-500/10 px-4 py-3 font-semibold text-rose-100 transition-colors hover:bg-rose-500/20 hover:text-white"
                        onClick={openPaymentOptions}
                    >
                        <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            className="h-5 w-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect x="3" y="5" width="18" height="14" rx="2" />
                            <path d="M3 10h18" />
                            <path d="M7 15h4" />
                        </svg>
                        Pagar con tarjetas
                    </button>

                    <button
                        className="btn-primary w-full px-4 py-3"
                        onClick={() => {
                            navigate("/payment-approved");
                        }}
                    >
                        Ya pagué!
                    </button>
                </div>
            </div>
        </ModalGeneric>
    );
}

export default CheckoutQR;
